<template>
  <div>采购订单列表</div>
</template>

<script>
export default {}
</script>

<style></style>
